import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchCrmMembers } from 'api/account';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';
import { CrmMember } from 'types/domain';

interface UseCrmMembers {
    limit?: number;
    query?: string;
}

const useCrmMembers = (
    params: UseCrmMembers = { limit: 9999, query: undefined },
    allowGivebutter = false,
) => {
    const { accountId } = useCurrentAccount();
    return useSuspenseQuery({
        queryKey: accountQueryKeys.crmMembersWithFilters(accountId, params),
        queryFn: () => fetchCrmMembers(accountId, params),
        select: data => {
            return [
                ...(allowGivebutter
                    ? [
                          {
                              id: -1,
                              first_name: 'Givebutter',
                              last_name: '',
                          } as CrmMember,
                      ]
                    : []),
                ...data.data,
            ];
        },
    });
};

export { useCrmMembers };
